import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { AInvoiceSliceState } from "../../utils/invoice.types";
import { ApiStatus } from "../../utils/api.types";
import { CashInflowPaymentsSliceState } from "../../utils/cashinflow.types";
import { addCashInflowPayment, attachInvoiceToPayment, fetchCashInflowPaymentsDetails, deletePaymentReceipt } from "./cashInflowThunk";

/**
 * CashInflow slice initial state.
 */
const initialState: CashInflowPaymentsSliceState = {
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * Invoice Slice.
 */
const cashInflowSlice = createSlice({
    name: 'cashInflow',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch payment receipt application
            .addCase(fetchCashInflowPaymentsDetails.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCashInflowPaymentsDetails.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.payments = action?.payload.payments || [];
                state.errorMessage = '';
            })
            .addCase(fetchCashInflowPaymentsDetails.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add payment
            .addCase(addCashInflowPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addCashInflowPayment.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                const { message } = action.payload
                toast.success(message);
                state.errorMessage = '';
            })
            .addCase(addCashInflowPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Attach invoice to payment
            .addCase(attachInvoiceToPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(attachInvoiceToPayment.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
            })
            .addCase(attachInvoiceToPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Delete payment receipt
            .addCase(deletePaymentReceipt.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deletePaymentReceipt.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                const { message } = action.payload;
                toast.success(message || 'Payment deleted successfully');
                state.errorMessage = '';
            })
            .addCase(deletePaymentReceipt.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to delete payment');
            })
            

    }
});

export default cashInflowSlice.reducer;
